import { getLocationPaymentMethods, getPersonPaymentMethods } from '@frontend/api-payment-plans';
import { useScopedQuery } from '@frontend/scope';

/**
 * @deprecated use PaymentPlanQueries from @frontend/api-payment-plans
 */
export const useGetPatientPaymentMethods = (patientId: string | undefined, locationId: string | undefined) => {
  const {
    isLoading,
    error: paymentMethodsError,
    data,
    refetch,
  } = useScopedQuery({
    queryKey: ['payment-plan-billing-methods', patientId],
    enabled: !!patientId && !!locationId,
    queryFn: () => getPersonPaymentMethods(patientId || '', locationId || ''),
  });

  const { data: setupLinkData, isFetched: setupLinkFetched } = useScopedQuery({
    queryKey: ['payments-location-setup'],
    enabled: !!locationId,
    queryFn: () => getLocationPaymentMethods(locationId || ''),
  });
  const setupLink = setupLinkData?.links?.setups;

  return {
    paymentMethods: data,
    setupLink,
    isLoading,
    setupLinkFetched: setupLinkFetched && setupLink,
    paymentMethodsError,
    refetch,
  };
};
